var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.form.placeholders),function(placeholder,index){return _c('div',{key:index},[_c('document-placeholder',{attrs:{"placeholder":placeholder},model:{value:(_vm.form.placeholders[index].value),callback:function ($$v) {_vm.$set(_vm.form.placeholders[index], "value", $$v)},expression:"form.placeholders[index].value"}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }